import {ChangeDetectorRef, Component, Inject, ViewChild} from "@angular/core";
import {
  FelloAddressStatus,
  FelloCustomAddressEntry,
  FelloFormChoiceVisitorVar,
  FelloOfferJourneyType,
  FelloVisitorVariables
} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {NgForm} from "@angular/forms";
import {GlobalTrackingEventService, GoogleStreetViewImageService, TrackedEvents} from "fello-common";
import {distinctUntilChanged, switchMap} from "rxjs/operators";
import {of} from "rxjs";

@Component({
  selector: "app-que-user-address-verify",
  templateUrl: "./que-user-address-verify.component.html",
  styleUrls: ["./que-user-address-verify.component.scss"]
})
export class QueUserAddressVerifyComponent extends QuestionCardDirective {
  customAddress: FelloCustomAddressEntry;
  @ViewChild("verifyAddress") verifyAddress?: NgForm;
  journeyType: FelloOfferJourneyType;
  FelloOfferJourneyType = FelloOfferJourneyType;
  selectedChoiceName: string;

  img$ = this.offerJourneyService.felloOfferJourney.pipe(
    distinctUntilChanged((j1, j2) => j1.vars.address !== j2.vars.address),
    switchMap(journey => {
      // if (journey.vars.img) {
      //   return of(journey.vars.img);
      // }
      return this.googleStreetViewImageService.getImageFromAddress(journey.vars.address);
    })
  );
  get isReferralJourney(): boolean {
    return this.journeyType === FelloOfferJourneyType.RL;
  }

  get isInvalidAddress(): boolean {
    return (
      this.offerJourney.addressStatus === FelloAddressStatus.VALIDATION_FAILED ||
      this.offerJourney.addressStatus === FelloAddressStatus.CUSTOM_VFAILED
    );
  }

  get formChoices(): FelloFormChoiceVisitorVar[] | undefined {
    return this.offerJourney.vars.formChoices;
  }

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    private cd: ChangeDetectorRef,
    private globalTrackingEventService: GlobalTrackingEventService,
    private googleStreetViewImageService: GoogleStreetViewImageService
  ) {
    super(offerJourneyService, taskId);
    this.journeyType = this.offerJourney.journeyType;
    this.customAddress = this.offerJourney.vars.customAddress ?? {
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: ""
    };
    const selectedChoice = this.formChoices?.find(a => a.formId === this.offerJourney.vars.selectedFormId);
    this.selectedChoiceName = selectedChoice?.title ?? "";
  }

  updateAddress(): void {
    const vars: FelloVisitorVariables = {
      customAddress: this.customAddress
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe(() => {
      this.editMode = false;
    });
  }

  toggleEdit(): void {
    this.editMode = !this.editMode;
    this.cd.detectChanges();
  }

  next(choice: FelloFormChoiceVisitorVar): void {
    this.selectedChoiceName = choice.title;
    const vars: FelloVisitorVariables = {
      selectedFormId: choice.formId
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe(() =>
      this.globalTrackingEventService.trackCustomEvent(TrackedEvents.ADDRESS_CONFIRMED, {
        address: this.offerJourney?.vars?.address
      })
    );
  }
}
